export default __webpack_public_path__ + "static/media/woman-taking-freshly-baked-jem-pie-out-oven@2x.e4a36bd1.png";